import React, { forwardRef } from 'react';

import {
    Button, Dialog, DialogActions,
    DialogContent, DialogTitle, Slide, Alert
} from '@mui/material';
import { useSelector } from 'react-redux';
import useCustomAlert from '../hooks/useCustomAlert';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

export default function CustomAlert() {

    const alert = useSelector(state => state.alert);
    const customAlert = useCustomAlert();

    const handleClose = () => {
        customAlert.hide();
    };

    const onAgree = () => {
        if(alert.onClose) {
            alert.onClose();
        }
        customAlert.hide();
    }

    return (
        <Dialog
            open={alert.show}
            TransitionComponent={Transition}
            keepMounted
            //onClose={handleClose}
            onClose={() => {
        
            }}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle sx={{ textTransform: 'capitalize' }} >{alert.severity}</DialogTitle>
            <DialogContent>
                <Alert severity={alert.severity || 'info'} >{alert.message}</Alert>
            </DialogContent>
            <DialogActions>
                <Button size='large' variant='outlined' onClick={handleClose}  className="black-border-button">Cancel</Button>
                <Button size='large' variant='contained' color={alert.severity || 'primary'} 
                    onClick={onAgree}
                    className="blue-button"
                >Ok</Button>
            </DialogActions>
        </Dialog>
    );
}